var map = {
	"./Benza.png": 1408,
	"./DeLonghi.png": 1624,
	"./Grandimpianti.png": 6045,
	"./IPSO.png": 1854,
	"./Italclean.png": 9545,
	"./Kranzle.png": 3225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4037;